import React, { Component } from 'react'
import { Card, Input, Button, Form, message } from 'antd'
import { compose, graphql } from 'react-apollo'
import gql from 'graphql-tag'

const FormItem = Form.Item

class ResetPasswordInput extends Component {
  state = {
    email: ''
  }

  handleChangeEmail = e => {
    this.setState({
      email: e.target.value
    })
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { email } = values
        this.props.checkResetPassword({ variables: { email } }).then(res => {
          if (!res.data.checkResetPassword) {
            message.error('Email not found')
          } else {
            message.success('We sent you a link to your email')
            setTimeout(() => {
              this.props.history.push('/')
            }, 3000)
          }
        })
      }
    })
  }

  render () {
    const { getFieldDecorator } = this.props.form
    return (
      <div
        style={{ background: '#ECECEC', height: '100vh' }}
        className="resetPasswordBox"
      >
        <Card
          title="Reset Password"
          bordered={false}
          style={{ width: 300, height: 400 }}
        >
          <Form onSubmit={this.handleSubmit}>
            <FormItem label="E-mail" hasFeedback>
              {getFieldDecorator('email', {
                rules: [
                  {
                    type: 'email',
                    message: 'The input is not valid E-mail!'
                  },
                  {
                    required: true,
                    message: 'Please input your E-mail!'
                  }
                ]
              })(<Input />)}
            </FormItem>
            <div className="resetPasswordBtn">
              <Button type="primary" htmlType="submit">Submit</Button>
            </div>
          </Form>
        </Card>
      </div>
    )
  }
}

const checkResetPassword = gql`
    mutation checkResetPassword($email: String!){
        checkResetPassword(email: $email) {
            email
        }
    }
`

export default compose(
  Form.create(),
  graphql(checkResetPassword, {
    name: 'checkResetPassword'
  })
)(ResetPasswordInput)



// WEBPACK FOOTER //
// ./src/App/ResetPasswordInput/ResetPasswordInput.js